import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { LangProvider } from "./lib/i18n";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { About } from "./components/site/About";
import { NoCoperto } from "./components/site/NoCoperto";
import { Menu } from "./components/site/Menu";
import { Testimonials } from "./components/site/Testimonials";
import { Reservation } from "./components/site/Reservation";
import { Asporto } from "./components/site/Asporto";
import { Contact } from "./components/site/Contact";
import { WhatsAppFab } from "./components/site/WhatsAppFab";
import { AdminApp } from "./components/admin/AdminApp";

function App() {
  const isAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <>
        <AdminApp />
        <Toaster richColors position="top-center" />
      </>
    );
  }

  return (
    <LangProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <About />
          <NoCoperto />
          <Menu />
          <Testimonials />
          <Reservation />
          <Asporto />
          <Contact />
        </main>
        <WhatsAppFab />
        <Toaster
          richColors
          position="top-center"
          toastOptions={{
            classNames: {
              toast: "font-sans",
            },
          }}
        />
      </div>
    </LangProvider>
  );
}

export default App;
